import React from 'react';
import Box from '@mui/material/Box';
import { Sponsors, SponsorsProps } from 'src/components/leaderboards/Sponsors';
import { DialogCentered } from 'src/components/DialogCentered';
import { SxProps } from '@mui/material/styles';

export type BracketPanelProps = {
  MatchDetails?: React.ReactNode;
  onClose: () => void;
  sx?: SxProps;
} & SponsorsProps;

export function BracketPanel(props: BracketPanelProps) {
  const { MatchDetails, onClose } = props;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {!!MatchDetails && (
        <DialogCentered
          open={!!MatchDetails}
          onClose={onClose}
          innerSx={{ p: 0, pt: -2 }}
          sx={{ '.MuiPaper-root': { overflow: 'visible' } }}
          contentSx={{ overflow: 'visible' }}
        >
          {MatchDetails}
        </DialogCentered>
      )}
      {!MatchDetails && <Sponsors {...props} />}
    </Box>
  );
}
